/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_Twittertitle1Inputs */

const ja_calendar_meta_twittertitle1 = /** @type {(inputs: Calendar_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN | 配信・番組実績`)
};

const en_calendar_meta_twittertitle1 = /** @type {(inputs: Calendar_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Esports Broadcasts & Livestreams`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Esports Broadcasts & Livestreams" |
*
* @param {Calendar_Meta_Twittertitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const calendar_meta_twittertitle1 = /** @type {((inputs?: Calendar_Meta_Twittertitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_Twittertitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_twittertitle1(inputs)
	return en_calendar_meta_twittertitle1(inputs)
});
export { calendar_meta_twittertitle1 as "calendar_meta_twitterTitle" }